import { render, staticRenderFns } from "./BackupBots.vue?vue&type=template&id=17362cf0&scoped=true&"
import script from "./BackupBots.vue?vue&type=script&lang=js&"
export * from "./BackupBots.vue?vue&type=script&lang=js&"
import style0 from "./BackupBots.vue?vue&type=style&index=0&id=17362cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17362cf0",
  null
  
)

export default component.exports